import React, { useState, useEffect } from "react";
import classnames from "classnames";
import {
  DRM_VIDEO_STATUS,
  getDrmStatusMessage,
  getVdoCipherIframeUrl,
} from "constants/recordedContent";
import { fetchVdoCipherVideoOtp } from "schedule-v2/RecordedContent/RecordedContent.helpers";
import moduleStyles from "./ContentRow.module.css";
import ExlySpinner from "ui/modules/ExlySpinner/ExlySpinner";
import { ReactComponent as GalleryIcon } from "assets/vectors/gallery.svg";

function VdoCipherVideo({ content = {} }) {
  const { drm_video_status } = content;
  return drm_video_status === DRM_VIDEO_STATUS.READY ? (
    <VdoCipherVideoChild content={content} />
  ) : (
    <div className={classnames(moduleStyles.emptyState)}>
      <GalleryIcon className={moduleStyles.galleryIcon} />
      <div>{getDrmStatusMessage(drm_video_status)}</div>
    </div>
  );
}

function VdoCipherVideoChild({ content = {} }) {
  const [videoDetails, setVedioDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const { uuid, title } = content;

  useEffect(() => {
    setLoading(true);
    fetchVdoCipherVideoOtp(uuid)
      .then(setVedioDetails)
      .catch((err) =>
        console.log(`Error fetching OTP / Verification Code/: ${err?.message}`)
      )
      .finally(() => setLoading(false));
  }, [uuid]);

  const { otp_settings } = videoDetails || {};

  if (loading) return <ExlySpinner loaderWidth="48px" />;

  return (
    <iframe
      title={title}
      src={getVdoCipherIframeUrl(otp_settings)}
      allow="encrypted-media"
      allowFullScreen
      className={moduleStyles.videoIframe}
    ></iframe>
  );
}

export default VdoCipherVideo;
